import gql from 'graphql-tag';

const DEVICE_LOCATION_LIST_VIEW = gql`
  query Query($searchQuery: String!, $limit: Int!, $skip: Int!) {
    deviceLocationQueriesListView(searchQuery: $searchQuery, limit: $limit, skip: $skip) {
      totalCount
      result {
        latitude
        longitude
        deviceType
        deviceSerialNo
        broker
        hardwareVersion
        isBillable
        version
        status
        simNumber
        networkProvider
        stage
        firmwareVersion
      }
    }
  }
`;

export default DEVICE_LOCATION_LIST_VIEW;
